import React from 'react';
import { Checkbox, Form } from 'antd';

const CommonCheckBox = ({ name, label, handleOnChange, checked = false }) => {
  return (
    <Form.Item name={name} valuePropName="checked" >
      <Checkbox onChange={handleOnChange} checked={checked}>{label}</Checkbox>
    </Form.Item>
  );
};

export default CommonCheckBox;
